import { useEffect, useRef, useState } from 'react';
import { first, last } from 'lodash';
import { HStack, View } from 'native-base';

import { SidebarMenuItem, useSidebarMenu } from '../hooks/sidebar-menu.hook';
import { EquipmentProfileView } from './equipment-profile-view';
import { GeneralInfoView } from './general-info-view';
import { SidebarMenu } from './sidebar-menu';
import { StoreHoursPage, StoreHoursPageHandle } from './store-hours-page';

type StoreConfigViewProps = {
  groupName?: string;
  initialPageModule?: string;
  initialPageSubModule?: string;
  onPageChange?: (pageModule?: string, pageSubModule?: string) => void;
};

export const StoreConfigView = ({ groupName, initialPageModule, initialPageSubModule, onPageChange }: StoreConfigViewProps) => {
  const sidebar = useSidebarMenu(groupName ?? 'storeConfig', { initialPageModule, initialPageSubModule, onPageChange });
  const tabItem = sidebar.activeItem;
  const tabName = first(tabItem?.name?.split('.'));
  const childName = last(tabItem?.name?.split('.'));

  const storeHoursRef = useRef<StoreHoursPageHandle>(null);

  // Track the last active EP sub-page so the view stays mounted (display: none)
  // when switching to other tabs — preserves unsaved form state.
  const [epState, setEpState] = useState<{ childName: string; title: string } | null>(null);

  useEffect(() => {
    if (tabName === 'equipmentProfile' && childName && tabItem?.label) {
      setEpState({ childName, title: tabItem.label });
    }
  }, [tabName, childName, tabItem?.label]);

  const handleSetActiveItem = (item: SidebarMenuItem | undefined) => {
    if (tabName === 'storeHours' && storeHoursRef.current) {
      storeHoursRef.current.requestNavigate(() => sidebar.setActiveItem(item));
    } else {
      sidebar.setActiveItem(item);
    }
  };

  return (
    <HStack flex={1}>
      <SidebarMenu {...sidebar} setActiveItem={handleSetActiveItem} />
      <View flex={1}>
        {tabName === 'generalInfo' && <GeneralInfoView />}
        {tabName === 'storeHours' && <StoreHoursPage ref={storeHoursRef} />}
        {!!epState && (
          <View flex={1} display={tabName === 'equipmentProfile' ? 'flex' : 'none'}>
            <EquipmentProfileView name={epState.childName} title={epState.title} />
          </View>
        )}
      </View>
    </HStack>
  );
};
